<template>
	<div class="min-height-inherit py-5">
		<div class="row align-items-center justify-content-center min-height-inherit">

			<div id="change-pwd-box" class="col-md-10 col-lg-8 col-xl-8 min-height-inherit">
				<div class="row justify-content-center px-4 pt-5 pb-4">

					<div class="col-12 text-center">
						<h1 class="fs-2-7 mb-4">Hai dimenticato la password?</h1>
						<p class="fs-1-3 semibold mb-5">Scrivi l’indirizzo email che hai usato per registrarti e riceverai un link per creare una nuova password.</p>
					</div>

					<div class="col-12">
						<form id="change-password-request" @submit.prevent="onSubmitForm">
							<div class="row justify-content-center">
								<div class="col-lg-10 col-xl-8 col-xxl-6 form-group mb-3">
									<label class="fs-0-9" for="e-mail">Email</label>
									<input type="email" name="e-mail" id="e-mail" class="form-control form-control-lg mb-0" required  autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="email" style="border-radius:50rem !important;border:2px solid #9AC10C !important;">
								</div>
								<div class="col-12 form-group text-center mt-4 mb-5">
									<button type="submit" id="sub-mail" class="btn btn-green rounded-pill btn-lg px-4"><span>INVIAMI IL LINK</span></button>
								</div>
							</div>
						</form>
					</div>
					<div class="col-12 text-center" v-html="formMsg"></div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'RequestChangePasswordComponent',

	data() {
		return {
			ajaxObj: window.ajax_object,
			email: '',
			formMsg: '',
			isBtnDisabled: false
		}
	},

	methods: {
		onSubmitForm() {
			let url = this.ajaxObj.ajax_url
			this.isBtnDisabled = true

			var data = new FormData();
			data.append('action', 'nl_change_password_link')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('email', this.email)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data);
					if(response.data.error == '') {
						this.formMsg = '<span class="bold">Link inviato!</span><br><span>Controlla la tua email, anche nella casella indesiderata o Spam.</span>'
						this.email = ''
					} else {
						this.formMsg = '<span>' + response.data.error + '</span>'
					}
					this.isBtnDisabled = false
				}, (error) => {
					this.isBtnDisabled = false
					console.log(error);
				});
		}
	}
}
</script>
